import React from 'react';
import { IIcons } from './types';

export const MedicalFlag = ({ color = '#566878' }: IIcons) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.3 9.25V7.9C9.3 7.40294 9.70294 7 10.2 7H13.8C14.2971 7 14.7 7.40294 14.7 7.9V9.25H15.6C16.0971 9.25 16.5 9.65294 16.5 10.15V15.55C16.5 16.0471 16.0971 16.45 15.6 16.45H8.4C7.90294 16.45 7.5 16.0471 7.5 15.55V10.15C7.5 9.65294 7.90294 9.25 8.4 9.25H9.3ZM10.2 9.25V7.9H13.8V9.25H10.2ZM11.55 12.4002V10.6002H12.45V12.4002H14.25V13.3002H12.45V15.1002H11.55V13.3002H9.75V12.4002H11.55Z"
            fill={color}
        />
    </svg>
);
